// extracted by mini-css-extract-plugin
export default {"root":"change-email_root__J7yPu","dialogButtons":"change-email_dialogButtons__0foV0","button":"change-email_button__3GWAV","cancel":"change-email_cancel__KgMoq"};